module.exports = __webpack_public_path__ + "img/Anya_O_19.f309b17e.jpg";